import React from 'react'

import { HouseStudyDayIndividualCapacityFields } from './components/capacity-fields/HouseStudyDayIndividualCapacityFields'
import { HouseStudyDayIndividualSeasonalPricesFields } from './components/seasonal-prices-fields/HouseStudyDayIndividualSeasonalPricesFields'
import { HouseStudyDayIndividualVatField } from './components/vat-field/HouseStudyDayIndividualVatField'
import { HouseStudyDayIndividualFieldProps } from '../form-container/HouseStudyDayIndividualFormContainer'
import { Divider } from '../../../../../../../../atoms/divider/Divider'

export const HouseStudyDayIndividualOptionsFields = ({
  currencyArea,
  ...fieldProps
}: HouseStudyDayIndividualFieldProps) => {
  return (
    <>
      <Divider />

      <HouseStudyDayIndividualCapacityFields {...fieldProps} />

      <Divider />

      <HouseStudyDayIndividualSeasonalPricesFields
        {...fieldProps}
        currencyArea={currencyArea}
      />

      <Divider />

      <HouseStudyDayIndividualVatField
        {...fieldProps}
        currencyArea={currencyArea}
      />
    </>
  )
}
